export default (data = {}, selections = new Set([]), actions = []) => {

    const info = data[[...selections][0]]
    let permission = false;

    actions.forEach(action => {
        switch(action) {
            case 'delete':
                permission = !!info;
                break;
            case 'download':
                permission = !!info && !info.is_dir;
                break;
        }
    })

    return permission;
}